
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  constructor(public auth:AuthService,public messageService:MessageService,public common:CommonService) { }

  ngOnInit(): void {
  }

  changePassword(changePasswordForm:NgForm){
    this.common.showLoader()
    this.auth.changePassword(changePasswordForm.value).subscribe((res:any)=>{
      //console.log(res)
      if(res.result){
        // this.messageService.add({severity:'success', summary:'Password Changed Successfully', detail:"Please login Again"});
       
        this.auth.logout()
      }else{
        this.messageService.add({severity:'error', summary:res.message, detail:""});
      }
      this.common.stopLoader()

    },err=>{
      /* alert(err.error.message) */
      let errorKeys = Object.keys(err.error.errors);
      errorKeys.forEach(key => {
        //console.log(key)
        let value = err.error.errors[key][0];
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value);
    });
      //console.log(err)
      this.common.stopLoader()
    })
  }

  showPassword(e){
    if(e.target.previousSibling.getAttribute('type') == 'password'){
      e.target.previousSibling.setAttribute('type','text')
      e.target.classList.replace('fa-eye', 'fa-eye-slash')
    }
    else{
      
      e.target.previousSibling.setAttribute('type','password')
      e.target.classList.replace('fa-eye-slash', 'fa-eye')
    }
  }

}
